import { useQuery } from "@tanstack/react-query";
import { Block, BlockTitle, Button, List, ListItem, Page } from "konsta/react"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { UserTransaction } from "../models/Models";
import { Get } from "../helpers/AxiosHelper";
import { formatUSD } from "../utils";
import moment from "moment";
import TabBar from "../components/TabBar";
import { UserTransactionTypeCd } from "../enums";
import Lottie from "lottie-react";
import lottieSuccess from "../lotties/success.json";

const OrderPage = () => {
    const {orderId} = useParams()
    const [notFound, setNotFound] = useState(false)
    const [userTransaction, setUserTransaction] = useState<UserTransaction>()
    const navigate = useNavigate();

    useEffect(() => {
        if (!orderId || isNaN(Number(orderId))) {
            setNotFound(true)
            return
        }

        getOrder();
        if (!userTransaction?.isProcessed) {
            const interval = setInterval(async () => {
                await getOrder()
                if (userTransaction?.isProcessed) {
                    clearInterval(interval)
                }
            }, 10_000);
        }
        
    }, [orderId])

    async function getOrder() {
        const order = await Get<UserTransaction>('/api/order?orderId=' + orderId);
        if (order) {
            setUserTransaction(order)
        }
    }

    return <Page className=" pb-40">
        {userTransaction && userTransaction.product && <>
            <div className="flex justify-center  overflow-hidden">
                <Lottie animationData={lottieSuccess} renderer="svg" className="w-64 h-64" style={{overflow: "hidden"}}/>
            </div>
            <Block>
                <h1 className="text-md font-semibold text-primary">{userTransaction.orderNumber}</h1>
                <h1 className="text-2xl currency tracking-widest">{userTransaction.isProcessed ? 'Order Completed' : 'Order Placed'}</h1>
            </Block>

            <BlockTitle>Order Summary</BlockTitle>
            <List strong>
                <ListItem title={`Created`} after={<span className="currency text-primary tracking-widest">{moment.utc(userTransaction.createdAt).local().calendar()}</span>} />
                <ListItem title={`${userTransaction.quantity}X ${userTransaction.product!.name.substring(0, 50)}`} after={<span className="currency text-primary tracking-widest">{formatUSD(userTransaction.product!.price * userTransaction.quantity)}</span>} />
                {!userTransaction.product.isUsed && <ListItem title={`${userTransaction.quantity}X Setup Fee`} after={<span className="currency text-primary tracking-widest">{formatUSD(userTransaction.product!.setupFee * userTransaction.quantity)}</span>} />}
                <ListItem title={`Total`} after={<span className="currency text-primary tracking-widest">{formatUSD((userTransaction.product!.price * userTransaction.quantity) + (userTransaction.product.isUsed ? 0 : (userTransaction.product!.setupFee * userTransaction.quantity)))}</span>} />
                <ListItem title={`Status`} after={<span className="currency text-primary tracking-widest">{userTransaction.isProcessed ? 'Completed' : 'Pending'}</span>} />

                {userTransaction.isProcessed && userTransaction.completedAt && <ListItem title={`Completed`} after={<span className="currency text-primary tracking-widest">{moment.utc(userTransaction.completedAt).local().calendar()}</span>} />}
            </List>

            <Block>
                <Button onClick={() => navigate('/')}>
                    Go to Home Page
                </Button>
            </Block>

            <TabBar selectedTab="store"/>
        </>}
    </Page>
}

export default OrderPage